import React from "react"
import styled, { css } from "styled-components"
import { CarouselProvider, ButtonBack, ButtonNext, DotGroup, Dot } from "pure-react-carousel"
import Icon from "icons"
import { maxWidth, minWidth } from "utils"
import CroppedImage from "components/cropped-image"

export { Slider, Slide } from "pure-react-carousel"

export const Wrapper = styled.div`
  width: calc(100% - 5.4rem);
  margin: 0 2.7rem;

  ${minWidth.tablet`
    width: calc(100% - 8rem);
    margin: 0 4rem 4rem;
  `}

  ${minWidth.hamburgerLarge`
    width: calc(100% - 12rem);
    margin: 0 6rem 6rem;
  `}
`

export const Title = styled.h3`
  margin-bottom: 1.7rem;
  padding-bottom: 0.6rem;
  border-bottom: 5px solid #eee;
  font-family: "Abril", "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 2.4rem;
  font-weight: 500;
  line-height: 1.5;
  letter-spacing: normal;
  color: ${({ theme }) => theme.colors.text.primary};

  p {
    margin: 0;
  }
`

export const Carousel = styled(CarouselProvider)`
  position: relative;
  cursor: grab;

  :active {
    cursor: grabbing;
  }

  li.carousel__slide {
    height: auto;
    padding-bottom: 0 !important;
  }

  div.carousel__inner-slide {
    position: static;
  }
`

export const SlideWrapper = styled.div`
  position: relative;
`

export const SlideTextWrapper = styled.div`
  margin-top: 1.4rem;
  padding-bottom: 1.5rem;

  ${maxWidth.mobile`
    margin-bottom: -2rem;
    padding-bottom: 0;
  `}

  ${minWidth.tablet`
    border-bottom: 3px solid #eee;
  `}
`

const Text = css`
  font-family: Maax, "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 1.6rem;
  line-height: 1.35;
  letter-spacing: normal;
  color: ${({ theme }) => theme.colors.text.primary};

  p {
    margin: 0;
  }
`

export const SlideTitle = styled.div`
  ${Text}
  font-weight: 500;
`

export const SlideText = styled.div`
  ${Text}
`

export const SlideMetaData = styled.div`
  margin-top: 1rem;
  font-family: Maax, "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 1.4rem;
  font-weight: 500;
  line-height: normal;
  letter-spacing: normal;
  color: #767676;
`

export const ImageCropped = styled(CroppedImage)`
  padding-top: 66.66%;
`

const GalleryIcon = styled(Icon)`
  position: absolute;
  top: calc(40% - 4.15rem);

  ${maxWidth.mobile`
    display: none;
  `}
`

export const ArrowLeft = () => (
  <ButtonBack>
    <GalleryIcon id="arrow-icon" style={{ left: "-4.15rem", transform: "rotate(180deg)" }} />
  </ButtonBack>
)

export const ArrowRight = () => (
  <ButtonNext>
    <GalleryIcon id="arrow-icon" style={{ right: "-4.15rem" }} />
  </ButtonNext>
)

export const DotWrapper = styled(DotGroup)`
  margin-bottom: 4rem;
  padding-bottom: 1.5rem;
  border-bottom: 3px solid #eee;
  display: flex;
  justify-content: center;

  .carousel__dot--selected {
    background-color: ${({ theme }) => theme.colors.text.primary};
  }

  ${minWidth.tablet`
    display: none;
  `}
`

export const StyledDot = styled(Dot)`
  width: 1rem;
  height: 1rem;
  margin: 0 0.25rem;
  border-radius: 50%;
  display: inline-block;
  background-color: #d8d8d8;
  transition: background-color 0.25s ease-in-out;
`
